import axios from 'axios';
import { collectionFilter } from '../../mixins/collectionFilter';
import productCard from '../collection-card/product-card-filterable.vue';

export default {
  name: 'allpaabaCollectionGrid',
  components: {
    ProductCard: productCard,
  },
  mixins: [collectionFilter],
  props: ['collectionId'],
  data() {
    return {
      showMore: false,
      showMoreTwo: false,
      products: [],
      urlFilterParam: '',
      urlFilterMatch: false,
    };
  },
  computed: {
    gridProducts: function () {
      // first, filter products
      let filtered = this.products.filter(
        (p) => p.colorways.length > 0 || p.hasOwnProperty('delDiaVersion')
      );

      // then use new color system if exists on colorway, or default to old one (ideally we can ditch the old one altogether eventually)
      filtered.forEach((product) => {
        product.colorways.forEach((colorway) => {
          // if new system exists, use that value or swatch
          if (colorway.color && colorway.color.hexCode) {
            colorway.swatch = colorway.color.hexCode;
          } else {
            // else, default to old value and add '#'
            colorway.swatch = '#' + colorway.hexValue;
          }
        });
      });

      //url tag param filter
      if (this.urlFilterMatch === true) {
        let urlFiltered = []; //we are going to build this array up and use it's results.
        filtered
          .filter((product) => product.tags.indexOf(this.urlFilterParam) > -1) //using indexOf to determine an exact match. Otherwise 'men' gets included in 'women' tags
          .forEach((e) => urlFiltered.push(e));
        filtered = urlFiltered;
      }
      return filtered;
    },
  },
  methods: {
    // if tag exists
    tagExists(needle, haystack) {
      if (haystack.includes(needle)) {
        return true;
      }
      return false;
    },

    // switch images
    // switchImages(color, img, product, isDelDia){
    // 	product.activeColor = color;
    // 	if(isDelDia === false){
    // 		product.featuredImage = img;
    // 	}
    // 	product.isDelDia = isDelDia;
    // 	this.$forceUpdate(); //this is used to get images to swap when the del dia color swatch is clicked.
    // },

    //get the products
    getCollection() {
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';

      axios
        // if visiblity param is provided, call the API with that attached.
        //.get(targetdomain + `/collection/getChoiceCollectionAndProductsByCollectionId/268005867581`)
        .get(
          targetdomain +
            `/collection/getStorefrontCollectionByCollectionId/${this.collectionId}`
        )
        .then((response) => {
          this.products = response.data.products;
          this.products.forEach((product) => {
            product.isDelDia = false;
            product.activeColor = '';
            if (product.colorways.length > 0) {
              this.switchImages(
                product.colorways[0].name,
                product.colorways[0].image,
                product,
                false
              ); //set the first swatch to be the 'active' one.
            } else if (product.hasOwnProperty('delDiaVersion')) {
              this.switchImages('delDia', null, product, true); //if we have no color swatches, then we need to set the del dia item as the active swatch.
            }
          });
          this.getUrlTagFilterParam();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUrlTagFilterParam() {
      let urlTagFilter = new URL(window.location.href).searchParams.get('tag');

      if (urlTagFilter) {
        //checks filter param against product tags and returns true for a match
        this.products.forEach((prod) => {
          if (prod.tags.indexOf(this.urlFilterParam) > -1) {
            this.urlFilterMatch = true;
            urlFilterParam = urlTagFilter;
            return;
          }
        });
      }
    },
  },
  //beforeMount() {},
  mounted() {
    this.getCollection();
  },
};
